import * as React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

import { IBuildingTreeItemAction } from 'models';

interface BuildingTreeItemHeaderProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  actions: Array<IBuildingTreeItemAction>;
  disabled?: boolean;
  paddingRight?: number;
}

export const BuildingTreeItemHeader: React.FC<BuildingTreeItemHeaderProps> = (props) => {
  const { icon, title, subtitle, actions, disabled = false, paddingRight = 0 } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        paddingRight,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          marginTop: 0.4,
        }}
      >
        <Typography
          color="textSecondary"
          sx={{
            margin: 0,
          }}
        >
          {icon}
        </Typography>
      </Box>

      <Box
        sx={
          icon
            ? {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                marginLeft: 4,
              }
            : {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }
        }
      >
        <Typography color="textSecondary" sx={icon ? { fontWeight: 600 } : {}}>
          {title}
        </Typography>

        {subtitle && (
          <Typography
            color="primary"
            sx={{
              fontSize: 14,
              fontWeight: 600,
              marginLeft: 1,
            }}
          >
            {subtitle}
          </Typography>
        )}

        {!disabled && (
          <Box
            sx={{
              marginLeft: 'auto',
            }}
          >
            {actions.map((action, key) => (
              <Tooltip key={`action-${key}-${Date.now()}`} title={action.tooltip} placement="top" arrow>
                <IconButton
                  size="small"
                  color="primary"
                  onClick={(event) => {
                    event.stopPropagation();

                    action.onClick();
                  }}
                >
                  {action.icon}
                </IconButton>
              </Tooltip>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};
